/**
 * 【【KYMW2100】VO
 *
 * @export OrderNumModel
 * @class OrderNumModel
 */
export class OrderNumModel {
  /** Ｐコード */
  public PCode: string;
  /** アイテムコード */
  public ItemCode: string;
  /** 注文コード */
  public OrderNum: string;
  /** クーポン商品連番 */
  public CouponGoodsNo: string;
  /** クーポン区分 */
  public CouponDiv: string;
  /** 予約詳細情報ID */
  public PreOrderDetailId: string;
  /** 1物N価詳細情報ID */
  public NvalDetailId: string;
}
